
/**
 * Clase responsable de procesar 
 * las excepciones del servidor SBSuite
 *
 * @export
 * @class SBSuiteResponse
 */
export class SBSuiteException{


    /**
     * Excepciones de SBSuite
     *
     * @static
     * @type {{
     *         CAMBIAR_OPERARIO_NO_CODE: 'NO_OPERATOR_CODE';
     *         CAMBIAR_OPERARIO_NO_ARRAY: 'NO_ARRAY';
     *         CAMBIAR_OPERARIO_BAD_ARRAY: 'BAD_ARRAY';
     *     }}
     * @memberof SBSuiteException
     */
    public static readonly EXCEPTIONS = {
        CAMBIAR_OPERARIO_NO_CODE: 'NO_OPERATOR_CODE',
        CAMBIAR_OPERARIO_NO_ARRAY: 'NO_ARRAY',
        CAMBIAR_OPERARIO_BAD_ARRAY: 'BAD_ARRAY',
        SESSION_INVALID: "Token incorrecto",
        SESSION_EXPIRED: "Token caducado"
    }
}


// WEBPACK FOOTER //
// ./src/modules/sbsuite/models/sbsuite-exception.model.ts